import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { GetRankResponseData } from '@/modules/manage-rank/type'
import RankTable from '../RankTable'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'

interface RankListingProps {
	data: GetRankResponseData[]
	total: number
	isLoading?: boolean
}

export default function RankListing({
	data,
	total,
	isLoading,
}: RankListingProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_RANK,
	)

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`รายการ Rank    `} description="รายการ Rank" />
				{hasWritePermission && (
					<Button asChild variant="default">
						<Link to="/operator/rank/create-rank">เพิ่ม Rank</Link>
					</Button>
				)}
			</div>
			<Separator />
			<RankTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
